import { useEffect, useState } from "react";

import { ROUTES } from "@/constants/routes";
import { useLoggedInUser } from "@/hooks/useLoggedInUser";
import { providerService } from "@/services/provider";

let cachedProviderMagicLinkSlug: string | undefined;
let providerMagicLinkRequest: Promise<string> | null = null;

const getProviderMagicLinkSlug = () => {
  if (cachedProviderMagicLinkSlug !== undefined) {
    return Promise.resolve(cachedProviderMagicLinkSlug);
  }

  if (!providerMagicLinkRequest) {
    providerMagicLinkRequest = providerService
      .getProviderMagicLink()
      .then((resp) => {
        cachedProviderMagicLinkSlug = resp?.data?.slug || "";
        return cachedProviderMagicLinkSlug;
      })
      .catch((error) => {
        providerMagicLinkRequest = null;
        throw error;
      });
  }

  return providerMagicLinkRequest;
};

export const useProviderMagicLink = () => {
  const currentUser = useLoggedInUser();
  const baseUrl = currentUser?.env?.frontendUrl || window.location.origin;
  const [providerLink, setProviderLink] = useState("");

  useEffect(() => {
    let isMounted = true;

    const fetchLink = async () => {
      try {
        const slug = await getProviderMagicLinkSlug();
        if (isMounted) {
          setProviderLink(
            slug ? `${baseUrl}${ROUTES.PROVIDER_TEST}${slug}` : ""
          );
        }
      } catch (e) {
        if (isMounted) {
          setProviderLink("");
        }
      }
    };

    fetchLink();

    return () => {
      isMounted = false;
    };
  }, [baseUrl]);

  return providerLink;
};
